import { range, takeWhile, last } from 'lodash'

const getDaysInMonth = (month, year) => new Date(year, month, 0).getDate()

export default function createDateObjects(date, weekOffset = 0) {
  const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 0)

  let diff = startOfMonth.getDay() - weekOffset
  if (diff < 0) diff += 7

  const prevMonthDays = range(diff, 0).map(n => ({
    day: new Date(date.getFullYear(), date.getMonth(), -n + 1),
    classNames: 'prevMonth',
  }))

  const daysInMonth = getDaysInMonth(date.getMonth() + 1, date.getFullYear())
  const currentMonthDays = range(1, daysInMonth + 1).map(index => ({
    day: new Date(date.getFullYear(), date.getMonth(), index, '16'),
  }))

  const daysAdded = prevMonthDays.length + currentMonthDays.length - 1

  const lastDayOfMonth = last(currentMonthDays).day
  const nextMonthDays = takeWhile(range(1, 7), n => (daysAdded + n) % 7 !== 0).map(n => ({
    day: new Date(
      lastDayOfMonth.getFullYear(),
      lastDayOfMonth.getMonth(),
      lastDayOfMonth.getDate() + n
    ),
    classNames: 'nextMonth',
  }))

  return [...prevMonthDays, ...currentMonthDays, ...nextMonthDays]
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/DatePicker/createDateObjects.js